import React from 'react';
import _ from 'lodash';

import { SummaryGroupPlaceholder } from 'app/components/domain/summary-group/product/summary-group-placeholder';
import { Card } from 'app/components/domain/card/card';
import { TotalPricesPlaceholder } from 'app/components/domain/total-prices/total-prices-placeholder';
import { CardPlaceholder } from 'app/components/domain/card-placeholder';

import styles from './order-details-placeholder.module.scss';

export const OrderDetailsPlaceholder: React.FC = () => (
    <>
        <div className={styles.container}>
            <Card>
                {_.range(3).map((index) => (
                    <SummaryGroupPlaceholder key={index} />
                ))}
                <TotalPricesPlaceholder />
            </Card>
        </div>
        <CardPlaceholder descriptionCount={3} />
        <CardPlaceholder descriptionCount={1} />
    </>
);
